import React from "react";
import { Container, makeStyles, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import { DropdownMenuButton } from "../components-atoms";
import UnfoldMoreRoundedIcon from '@material-ui/icons/UnfoldMoreRounded';
import { ITheme, theme } from '../constants/theme';
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

interface IProps {
  selectedSortType: string;
  menuItems: Array<{
    title: string;
    value: string;
    handleSelect: Function;
  }>;
}
// import ClickAwayListener from "@material-ui/core/ClickAwayListener";
export default function SortButtonAndMenu(props: IProps) {
  const { selectedSortType, menuItems } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        startIcon={<UnfoldMoreRoundedIcon color="primary" />}
        onClick={handleClick}
        className={classes.button}
        style={{
          backgroundColor: open ? theme.palette.secondary.main : undefined,
        }}
      >
        {/* <img src={printIcon} className={classes.buttonIcon} alt="printIcon" /> */}
        <Typography
          variant="button"
          component="span"
          color="primary"
          className={classes.printButtonText}
        >
          Sort
        </Typography>
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className={classes.menu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          role: "listbox",
        }}
      >
        <Container className={classes.root}>
          {menuItems &&
            menuItems.map((i: any) => (
              <DropdownMenuButton
                key={i.title}
                title={i.title}
                value={i.value}
                handleClick={() => { i.handleSelect(); handleClose(); }}
                selected={selectedSortType === i.value ? true : false}
              />
            ))}
        </Container>
      </Menu>
    </div>
  );
}

const useStyles = makeStyles((theme: ITheme) => ({
  printButtonText: {
    textTransform: "none",
  },
  buttonIcon: {
    width: 18,
    height: 18,
    marginRight: 8,
  },
  menu: {
    marginTop: 120,
    borderRadius: 12,
  },
  root: {
    width: 256,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 28,
    paddingBottom: 28,
    borderRadius: 8,
  },
  button: {
    borderRadius: 8,
    ...textButtonHoverAndActive
  }
}));
